import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import CustomForm from '../../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../../config/config';
import Fetch from '../../../../../core/util/core/Fetch';
import { chooseProfileFilter } from '../../../../helpers/chooseProfileFilter';

function Suppliers() {
    const profileFilter = chooseProfileFilter();

    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const path = '/people/';
    const paths = {
        endpointSave: config.endpoints.backend + 'people/save',
        endpointGetAllPeopleContabilities:
            config.endpoints.backend + 'peoplecontabilities/getall',
        endpointGetAllSuppliers: config.endpoints.backend + 'people/getSuppliers',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    };

    const labels = {
        labelTitleEdit: 'Editar Fornecedores',
        labelTitleView: 'Visualizar Fornecedores'
    };

    const hiddenValues = {};

    if (profileFilter.pdc_company_id) {
        hiddenValues.pdc_company_id = profileFilter.pdc_company_id;
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                ...hiddenValues,
                id: values.id
            },
            fields: [
                {
                    name: 'suppliers',
                    type: 'multiinput',
                    label: 'Lista de Fornecedores',
                    sortBy: 'index',
                    form: [
                        {
                            name: 'pdc_supplier_id',
                            type: 'select',
                            label: 'Fornecedor',
                            options: [],
                            optionsEndpoint: {
                                endpoint: paths.endpointGetAllSuppliers,
                                params: {
                                    filter: {
                                        ...profileFilter
                                    }
                                },
                                label: 'corporate_name',
                                value: 'id'
                            },
                            validations: {
                                required: false
                            }
                        }
                    ],
                    validations: {
                        required: false
                    },
                    columnSize: 12
                }
            ],

            ...paths,
            ...labels
        };
        form.values = values;
        return form;
    };

    useEffect(() => {
        const load = async () => {
            let values = await Fetch.post(
                paths.endpointGetAllPeopleContabilities,
                {
                    filter: {
                        pdc_people_id: id
                    }
                }
            );

            if (values.length === 0) {
                values = {
                    suppliers: []
                };
            }


            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            );
        };
        load();
    }, []);

    return <div>{formContent}</div>;
}
export default Suppliers;
